import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { useSearch } from "wouter";

export default function Unauthorized() {
  const searchString = useSearch();
  const urlParams = new URLSearchParams(searchString);
  const reason = urlParams.get('reason');
  
  const getMessage = () => {
    switch (reason) {
      case 'disabled':
        return {
          title: "Account Disabled",
          description: "Your account has been disabled by an administrator. Please contact your system administrator for assistance.",
        };
      case 'not-invited':
        return {
          title: "Account Not Authorized",
          description: "Your account is not authorized to access this system. Please contact your administrator to request access.",
        };
      default:
        return {
          title: "Access Denied",
          description: "You do not have permission to access this system. Please contact your administrator.",
        };
    }
  };
  
  const { title, description } = getMessage();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-destructive/10 p-3">
              <AlertCircle className="h-8 w-8 text-destructive" />
            </div>
          </div>
          <CardTitle className="text-2xl">{title}</CardTitle>
          <CardDescription className="text-base mt-2">
            {description}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-muted p-4 rounded-lg">
            <p className="text-sm text-muted-foreground">
              <strong>Need help?</strong><br />
              Contact your system administrator to:
            </p>
            <ul className="list-disc list-inside text-sm text-muted-foreground mt-2 space-y-1">
              <li>Request access to the system</li>
              <li>Check your account status</li>
              <li>Get an invitation link</li>
            </ul>
          </div>
          
          <Button
            variant="outline"
            className="w-full"
            onClick={() => window.location.href = '/'}
          >
            Return to Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
